import moment from 'moment';

/**
 * @description 時間をMomentオブジェクトに変更、表示は23:59:59(HH:mm:ss)
 * @param {string} time 時間
 */
export const formatTime = time => {
  return moment(time, 'HH:mm:ss');
};

/**
 * @param {string} time 時間
 * @param {string} limitStart 作業時間の開始時間
 * @param {string} limitEnd 作業時間の終了時間
 */
export const isTimeInsideLimit = (time, limitStart, limitEnd) => {
  if (time === '') {
    return false;
  }
  let momentTime = formatTime(time);
  let momentStart = formatTime(limitStart);
  let momentEnd = formatTime(limitEnd);
  // 開始時間と終了時間が同じ場合、必ず範囲内なのでtrue
  if (momentStart.isSame(momentEnd)) {
    return true;
  }
  // 時間範囲が日跨ぎした場合の対応
  if (momentEnd.isBefore(momentStart) && momentTime.isBefore(momentStart)) {
    momentStart.subtract(24, 'hours');
  } else if (momentStart.isAfter(momentEnd)) {
    momentEnd.add(24, 'hours');
  }
  // 範囲内の場合 = true
  return (
    momentTime.isSameOrAfter(momentStart) &&
    momentTime.isSameOrBefore(momentEnd)
  );
};

/**
 * @description 期間がマイナスかのチェック
 * @param {string} time 期間
 */
export const timeIsNegative = time => {
  return moment.duration(time, 'minutes').asMinutes() < 0;
};

/**
 * @description 2桁変換処理
 *  戻り値は文字列
 */
export const convertDouble = n => {
  return `0${n}`.slice(-2);
};

/**
 * @description 分 → 時変換
 */
export const convertMinToTime = min => {
  const time = `${convertDouble(Math.floor(min / 60))}:${convertDouble(
    Math.floor(60 * (min / 60 - Math.floor(min / 60)))
  )}`;
  return time;
};

/**
 * @description 時 → 分変換 ※ 0:00が基準
 */
export const convertTimeToMin = time => {
  const _time = time.split(':');
  return Number(_time[0] * 60) + Number(_time[1]);
};

/**
 * @description HH:mm:ss → HH:mm変更
 * @param {string} time 時間
 */
export const formatHourMin = time => {
  return time.slice(0, -3);
};

/**
 * @description 24時内に変更（1920 → 480）//32時 → 8時
 * @param {number} time 時間（分）
 */
export const reduceTime24 = time => {
  return time % 1440;
};

/**
 * @description 人の年齢が指定した年齢の日前であるかをチェック
 * @param {string} birthday 誕生日
 * @param {number} years 年齢
 * @example
 * // 人が20歳の日前であるかをチェック
 * const isDayBeforeTwentiethBirthday = isDayBeforeXYearsOld('2004-01-01', 20);
 * // 現在が2024年1月1日以降の場合、true
 */
export const isDayBeforeXYearsOld = (birthday, years) => {
  const momentBirthday = moment(birthday);
  const dayBeforeXYears = momentBirthday
    .add(years, 'years')
    .subtract(1, 'days');
  // 本日がX歳になる誕生日(-1日)以降かチェック
  if (moment().isSameOrAfter(dayBeforeXYears, 'day')) {
    return true;
  } else {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/utilities/momentUtil.js